import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  noReviews: boolean;
}

export const Wrapper = styled.div`
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  margin: 5px 0;
  display: flex;
  flex-direction: column;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  min-height: 470px;
  position: relative;
  overflow: hidden;
  justify-content: ${(props: IWrapperProps) => props.noReviews && "center"};
  align-items: ${(props: IWrapperProps) => props.noReviews && "center"};
  color: ${(props: IWrapperProps) => props.noReviews && "#818181"};

  ${mediaMaxWidth.smallDesktop} {
    min-height: 520px;
    top: 10px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    margin: 5px auto;
    padding: 10px 10px 50px 10px;
  }
`;

export const Review = styled.div`
  padding: 0 10px;
  margin: 15px 0;

  ${mediaMaxWidth.smallDesktop} {
    height: unset;
  }
`;

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Info = styled.div``;

export const Name = styled.div`
  font-weight: 700;
  font-size: 0.95em;
  display: flex;
  align-items: center;
`;

export const Date = styled.div`
  font-size: 0.9em;
  color: #818181;
  font-style: italic;
`;

export const StarRating = styled.div`
  unicode-bidi: bidi-override;
  color: #ccc;
  font-size: 18px;
  position: relative;
  margin: 4px 0 0 0;
  padding: 0;
  width: 98px;
  letter-spacing: 2px;
`;

export const Stars = styled.span``;

export const FillRating = styled.div`
  color: #f2008c;
  padding: 0;
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;

  span {
    display: inline-block;
  }
`;

export const EmptyRating = styled.div`
  padding: 0;
  display: block;
  z-index: 0;
`;
export const Text = styled.div`
  margin: 10px 0 15px 0;
  font-size: 0.95em;
  font-style: italic;
  letter-spacing: 0.5px;
`;

export const ReadMore = styled.a`
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.95em;
  font-style: italic;
  color: #f2008c;

  &:hover {
    text-decoration: underline;
    color: #673490;
  }
`;

export const PaginationButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 180px;
  margin: 0 auto;
  font-size: 1em;
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;

  svg {
    font-size: 1.2em;
    margin: 0 5px;
  }
`;

export const PrevButtonWrapper = styled.div`
  width: 70px;
  display: flex;
  justify-content: center;
  height: 25px;
`;

export const PrevButton = styled.div`
  cursor: pointer;
  height: 25px;
  display: flex;
  align-items: center;

  &:hover {
    color: #f2008c;
  }
`;

export const NextButtonWrapper = styled.div`
  width: 70px;
  display: flex;
  justify-content: center;
  height: 25px;
`;

export const NextButton = styled.div`
  cursor: pointer;
  height: 25px;
  display: flex;
  align-items: center;

  &:hover {
    color: #f2008c;
  }
`;

export const FullReviewWrapper = styled.div`
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  padding: 10px;
`;

export const Author = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 0.95em;
  padding: 10px;
  margin: 5px 0;
  display: flex;
  justify-content: space-between;
`;

export const ReviewDate = styled.div`
  padding: 15px 10px;
  font-weight: 300;
  font-size: 0.95em;
  color: #818181;
  font-style: italic;
`;

export const FullReviewStarRating = styled.div`
  unicode-bidi: bidi-override;
  color: #ccc;
  font-size: 18px;
  position: absolute;
  right: 15px;
  top: 65px;
  margin: 4px 0 0 0;
  padding: 0;
  width: 98px;
  letter-spacing: 2px;
`;

export const ReviewText = styled.div`
  padding: 10px;
  font-style: italic;
  height: 330px;
  overflow: scroll;
  text-align: justify;

  ${mediaMaxWidth.smallDesktop} {
    height: 390px;
  }

  ${mediaMaxWidth.tablet} {
    height: 400px;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 18px;
  right: 20px;
  cursor: pointer;
  font-size: 1.4em;
  z-index: 1;

  &:hover {
    color: #f2008c;
  }
`;

export const VerifiedBadgeWrapper = styled.div`
  margin-left: 5px;
`;

export const VerifiedBadge = styled.div`
  background-color: #f2008c;
  color: #fff;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  font-size: 0.75em;
  display: flex;
  justify-content: center;
  align-items: center;
`;
